import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}

/**
 * Detect device type and OS
 */
export function useDeviceDetection() {
  const [deviceInfo, setDeviceInfo] = React.useState({
    isMobile: false,
    isIOS: false,
    isAndroid: false,
    isStandalone: false,
    isSafari: false,
  });

  React.useEffect(() => {
    const ua = navigator.userAgent;
    const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
    const isIOS = /iPhone|iPad|iPod/.test(ua);
    const isAndroid = /Android/.test(ua);
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                         (window.navigator as any).standalone === true;
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);

    setDeviceInfo({
      isMobile,
      isIOS,
      isAndroid,
      isStandalone,
      isSafari,
    });

    // Add device-specific classes to body
    document.body.classList.toggle('is-mobile', isMobile);
    document.body.classList.toggle('is-ios', isIOS);
    document.body.classList.toggle('is-android', isAndroid);
    document.body.classList.toggle('is-standalone', isStandalone);
  }, []);

  return deviceInfo;
}
